module.exports = __webpack_public_path__ + "img/jumex.c4053aed.png";